import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';
import installSupersetBlock from './components/Blocks/Superset';

// 1. Importa o ícone padrão do Plone e os nossos componentes do Superset
// Importamos um ícone SVG nativo que o Plone reconhece
import chartIcon from '@plone/volto/icons/bar-chart.svg';
import iconSVG from '@plone/volto/icons/world.svg';
import SupersetView from './components/Blocks/Superset/View';
import SupersetEdit from './components/Blocks/Superset/Edit';

function applyConfig(config: ConfigType) {
  installSettings(config);

  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['pt-br', 'en', 'es'];
  config.settings.defaultLanguage = 'pt-br';

  if (config.blocks.blocksConfig.slider) {
      config.blocks.blocksConfig.slider.enableAutoPlay = true;
  }


  installSupersetBlock(config);
  // --- INÍCIO DA LIBERAÇÃO DO SUPERSET (CSP) ---
  // 1. Garante que a estrutura exista para não dar erro de "undefined"
  config.settings.csp = config.settings.csp || {};
  config.settings.csp.directives = config.settings.csp.directives || {};
  
  // 2. Pega a lista atual ou cria o padrão 'self'
  const currentFrameSrc = config.settings.csp.directives['frame-src'] || ["'self'"];
  
  // 3. Adiciona o domínio do Superset (evitando duplicatas se o código rodar duas vezes)
  if (!currentFrameSrc.includes('https://vps.fmvz.usp.br/')) {
    config.settings.csp.directives['frame-src'] = [
      ...currentFrameSrc,
      'https://vps.fmvz.usp.br/'
    ];
  }
  // --- FIM DA LIBERAÇÃO ---
  return config;
}

export default applyConfig;
